<template>
  <div class="task-cards-root">
    <div v-if="shouldRender" class="task-cards-overscreen">
      <div v-if="!isMobile" class="task-cards-column">
        <div
          v-for="card in cards"
          @click="openTask(card)"
          :key="card.notificationId || card.taskId"
          class="task-card animate__animated animate__fadeInRight"
        >
          <div class="task-card-icon">
            <feather-icon icon="ClockIcon" size="18" color="#ff9f43" />
          </div>

          <div class="task-card-content">
            <div class="task-card-title" v-dompurify-html="card.title" />

            <div class="task-card-body" v-dompurify-html="card.body" />
          </div>

          <div @click.stop="dismiss(card)" class="task-card-close">
            <feather-icon icon="XIcon" size="18" />
          </div>
        </div>
      </div>

      <div
        v-else
        @click="openMobileModal()"
        class="task-cards-bell animate__animated animate__headShake animate__infinite"
      >
        <feather-icon icon="BellIcon" size="22" color="#ffffff" />

        <div class="task-cards-bell-badge">{{ count }}</div>
      </div>
    </div>

    <b-modal id="bv-overdue-task-cards" class="modal-dialog" hide-footer hide-header>
      <div class="task-cards-modal">
        <div class="task-cards-modal-header">
          <div>Tarefas a vencer ({{ count }})</div>

          <div @click="$bvModal.hide('bv-overdue-task-cards')" class="cursor-pointer">
            <feather-icon icon="XIcon" size="20" />
          </div>
        </div>

        <div class="task-cards-modal-list">
          <div
            v-for="card in cards"
            @click="openTask(card)"
            :key="card.notificationId || card.taskId"
            class="task-card mobile"
          >
            <div class="task-card-icon">
              <feather-icon icon="ClockIcon" size="18" color="#ff9f43" />
            </div>

            <div class="task-card-content">
              <div class="task-card-title" v-dompurify-html="card.title" />

              <div class="task-card-body" v-dompurify-html="card.body" />
            </div>

            <div @click.stop="dismiss(card)" class="task-card-close">
              <feather-icon icon="XIcon" size="18" />
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="bv-task-from-overdue-card" class="modal-dialog" hide-footer hide-header>
      <task-form
        @saved="$bvModal.hide('bv-task-from-overdue-card')"
        @deleted="$bvModal.hide('bv-task-from-overdue-card')"
        @close="$bvModal.hide('bv-task-from-overdue-card')"
        :task-id="currentTaskId"
      />
    </b-modal>
  </div>
</template>

<script>
import TaskForm from "@/views/forms/TaskForm.vue";

export default {
  components: {
    TaskForm,
  },

  data() {
    return {
      isMobile: window.innerWidth <= 800,

      currentTaskId: null,
    };
  },

  computed: {
    cards() {
      return this.$store.getters["taskNotificationCards/getCards"];
    },

    count() {
      return this.$store.getters["taskNotificationCards/getCount"];
    },

    shouldRender() {
      return this.count > 0 && this.$route.path !== "/login" && !!localStorage.getItem("token");
    },
  },

  watch: {
    count(value) {
      if (value === 0) this.$bvModal.hide("bv-overdue-task-cards");
    },
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 800;
    },

    openMobileModal() {
      this.$bvModal.show("bv-overdue-task-cards");
    },

    openTask(card) {
      this.currentTaskId = parseInt(card.taskId);

      this.$bvModal.hide("bv-overdue-task-cards");

      this.$bvModal.show("bv-task-from-overdue-card");

      this.$store.dispatch("taskNotificationCards/readAndRemove", card);
    },

    dismiss(card) {
      this.$store.dispatch("taskNotificationCards/readAndRemove", card);
    },
  },
};
</script>

<style lang="scss" scoped>
.task-cards-root {
  display: contents;
}

.task-cards-overscreen {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
  z-index: 999990;

  .task-cards-column {
    display: flex;
    flex-direction: column-reverse;
    position: absolute;
    top: 5rem;
    bottom: 1rem;
    right: 1rem;
    width: 340px;
    gap: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    pointer-events: none;

    &::-webkit-scrollbar {
      width: 0;
    }
  }

  .task-card {
    display: flex;
    align-items: flex-start;
    position: relative;
    gap: 10px;
    padding: 12px;
    border-radius: 6px;
    border: solid 1px #ff9f43;
    border-left: solid 3px #ff9f43;
    background: #fff4e8;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    pointer-events: all;
    cursor: pointer;

    .task-card-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 34px;
      min-width: 34px;
      border-radius: 100%;
      background: #ffe2c2;
    }

    .task-card-content {
      display: flex;
      flex-direction: column;
      flex: 1;
      gap: 2px;
      overflow: hidden;

      .task-card-title {
        font-size: 14px;
        font-weight: 600;
        color: #000000;
      }

      .task-card-body {
        font-size: 13px;
        color: #6e6b7b;
      }
    }

    .task-card-close {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 24px;
      height: 24px;
      border-radius: 50%;
      color: #6e6b7b;
      cursor: pointer;

      &:hover {
        background: #ffe2c2;
        color: #ff2c55;
      }
    }
  }

  .task-cards-bell {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 85px;
    right: 16px;
    height: 52px;
    width: 52px;
    border-radius: 50%;
    background: #ff9f43;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    pointer-events: all;
    cursor: pointer;

    .task-cards-bell-badge {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: -4px;
      right: -4px;
      min-width: 20px;
      height: 20px;
      padding: 0 5px;
      border-radius: 10px;
      border: 2px solid #ffffff;
      font-size: 11px;
      font-weight: 700;
      background: #ff2c55;
      color: #ffffff;
    }
  }
}

.task-cards-modal {
  display: flex;
  flex-direction: column;
  height: 100vh;
  gap: 12px;
  padding: 1rem;
  overflow: hidden;

  .task-cards-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .task-cards-modal-list {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 10px;
    overflow-y: auto;
  }

  .task-card {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px;
    border-radius: 6px;
    border: solid 1px #ff9f43;
    border-left: solid 3px #ff9f43;
    background: #fff4e8;
    cursor: pointer;

    .task-card-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 34px;
      min-width: 34px;
      border-radius: 100%;
      background: #ffe2c2;
    }

    .task-card-content {
      display: flex;
      flex-direction: column;
      flex: 1;
      gap: 2px;
      overflow: hidden;

      .task-card-title {
        font-size: 14px;
        font-weight: 600;
        color: #000000;
      }

      .task-card-body {
        font-size: 13px;
        color: #6e6b7b;
      }
    }

    .task-card-close {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 24px;
      height: 24px;
      border-radius: 50%;
      color: #6e6b7b;
      cursor: pointer;
    }
  }
}
</style>
